import React from "react";
// import $ from "jquery";
import "flowbite";
import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import LandingPage from "./layouts/landing-page";
import PageAbout from "./layouts/about";
import PageShop from "./layouts/shop";
import PageEvent from "./layouts/event";
import FeatureHeaderSatu from "./layouts/header-satu";
import FeatureHeaderDua from "./layouts/header-dua";
import FeatureHeaderTiga from "./layouts/header-tiga";
import GaleryRegular from "./layouts/galery-regular";
import GaleryCorousel from "./layouts/galery-corousel";
import GaleryFull from "./layouts/galery-full";
import ContactSatu from "./layouts/contact-satu";
import ContactDua from "./layouts/contact-dua";

class App extends React.Component {
  // componentDidMount() {

  // }

  render() {
    return (
      <BrowserRouter>
        <Routes>
          <Route path={"/"} element={<LandingPage />} />
          <Route path={"/page-about"} element={<PageAbout />} />
          <Route path={"/page-shop"} element={<PageShop />} />
          <Route path={"/page-event"} element={<PageEvent />} />
          <Route path={"/feature-header-satu"} element={<FeatureHeaderSatu />} />
          <Route path={"/feature-header-dua"} element={<FeatureHeaderDua />} />
          <Route path={"/feature-header-tiga"} element={<FeatureHeaderTiga />} />
          <Route path={"/galery-regular"} element={<GaleryRegular />} />
          <Route path={"/galery-corousel"} element={<GaleryCorousel />} />
          <Route path={"/galery-full"} element={<GaleryFull />} />
          <Route path={"/contact-satu"} element={<ContactSatu />} />
          <Route path={"/contact-dua"} element={<ContactDua />} />
        </Routes>
      </BrowserRouter>
    );
  }
}

export default App;
